import Vue from 'vue'
import Router from 'vue-router'
import AuthLayout from '../components/auth/AuthLayout'
import AppLayout from '../components/admin/AppLayout'

Vue.use(Router)

function guardMyroute(to, from, next) {
  var isAuthenticated = false
  if (localStorage.getItem('LoggedUser')) { isAuthenticated = true } else { isAuthenticated = false }
  if (isAuthenticated) {
    next() // allow to enter route
  } else {
    next('/auth/login') // go to '/login';
  }
}

const EmptyParentComponent = {
  template: '<router-view :key="$route.fullPath"></router-view>',
}

const demoRoutes = []

export default new Router({
  mode: process.env.VUE_APP_ROUTER_MODE_HISTORY === 'true' ? 'history' : 'hash',
  routes: [
    ...demoRoutes,
    {
      path: '*',
      redirect: { name: 'login' },
    },
    {
      path: '/auth',
      component: AuthLayout,
      children: [
        {
          name: 'login',
          path: 'login',
          component: () => import('../components/auth/login/Login.vue'),
        },
        {
          name: 'signup',
          path: 'signup',
          component: () => import('../components/auth/signup/Signup.vue'),
        },
        {
          name: 'recover-password',
          path: 'recover-password',
          component: () => import('../components/auth/recover-password/RecoverPassword.vue'),
        },
        {
          path: '',
          redirect: { name: 'login' },
        },
      ],
    },    
    {
      name: 'Admin',
      path: '/admin',
      component: AppLayout,
      children: [
        {
          name: 'dashboard',
          path: 'dashboard',
          beforeEnter: guardMyroute,
          component: () => import('../components/dashboard/Dashboard.vue'),
          default: true,
        },
        {
          name: 'member-reports',
          path: 'member-reports',
          component: EmptyParentComponent,
          children: [
            {
              name: 'MEMBSTMNT',
              path: 'MEMBSTMNT',
              beforeEnter: guardMyroute,
              component: () => import('../components/pdf/Test.vue'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/inputs',
              },
            },
            {
              name: 'DEPSTMNT',
              path: 'DEPSTMNT',
              component: () => import('../components/pdf/Test.vue'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Medium-Editor',
              },
            },
            {
              name: 'GUAREP',
              path: 'GUAREP',
              beforeEnter: guardMyroute,
              component: () => import('../components/pdf/Test.vue'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Medium-Editor',
              },
            },
            {
              name: 'GUALNS',
              path: 'GUALNS',
              beforeEnter: guardMyroute,
              component: () => import('../components/pdf/Test.vue'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Medium-Editor',
              },
            },
            {
              name: 'FOSASTMNT',
              path: 'FOSASTMNT',
              beforeEnter: guardMyroute,
              component: () => import('../components/pdf/Test.vue'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Medium-Editor',
              },
            },
            {
              name: 'LOANSTMNT',
              path: 'LOANSTMNT/:loan_no',
              beforeEnter: guardMyroute,
              component: () => import('../components/pdf/Test.vue'),
              meta: {
                wikiLink: 'https://github.com/epicmaxco/vuestic-admin/wiki/Medium-Editor',
              },
            },
          ],
        },
        {
          name: 'loans-center',
          path: 'loans-center',
          component: EmptyParentComponent,
          children: [
            {
              name: 'active-loans',
              path: 'active-loans',
              beforeEnter: guardMyroute,
              component: () => import('../components/loans/activeloans.vue'),
            },
            {
              name: 'loan',
              path: 'loan/:loan_no',
              beforeEnter: guardMyroute,
              component: () => import('../components/loans/loan.vue'),
            },
            {
              name: 'loan-applications',
              path: 'loan-applications',
              beforeEnter: guardMyroute,
              component: () => import('../components/LoanApplication/loanapplications.vue'),
            },
            {
              name: 'loan-EditLoan',
              path: 'loan-EditLoan/:loan_no',
              beforeEnter: guardMyroute,
              component: () => import('../components/LoanApplication/EditLoan.vue'),
            },
            {
              name: 'loan-MyAppliedLoans',
              path: 'loan-MyAppliedLoans',
              beforeEnter: guardMyroute,
              component: () => import('../components/LoanApplication/MyAppliedLoans.vue'),
            },
            {
              name: 'loan-LoansMoreDetails',
              path: 'loan-LoansMoreDetails/:loan_no',
              beforeEnter: guardMyroute,
              component: () => import('../components/LoanApplication/LoansMoreDetails.vue'),
            },
            {
              name: 'loan-GuarantorshipRequests',
              path: 'loan-GuarantorshipRequests',
              beforeEnter: guardMyroute,
              component: () => import('../components/LoanApplication/GuarantorshipRequests.vue'),
            },
          ],
        },
        {
          name: 'member-activities',
          path: 'member-activities',
          component: EmptyParentComponent,
          children: [
            {
              name: 'deposit-funds',
              path: 'deposit-funds',
              beforeEnter: guardMyroute,
              component: () => import('../components/member-activities/DepositFunds.vue'),
            },
            {
              name: 'funds-transfer',
              path: 'funds-transfer',
              beforeEnter: guardMyroute,
              component: () => import('../components/member-activities/FundsTransfer.vue'),
            },
            {
              name: 'cash-withdrawal',
              path: 'cash-withdrawal',
              beforeEnter: guardMyroute,
              component: () => import('../components/member-activities/CashWithraw.vue'),
            },
            {
              name: 'loans-payment',
              path: 'loans-payment',
              beforeEnter: guardMyroute,
              component: () => import('../components/loans/payloans.vue'),
            },
            {
              name: 'loan-calculator',
              path: 'loan-calculator',
              beforeEnter: guardMyroute,
              component: () => import('../components/loans/loancalculator.vue'),
            },
            {
              name: 'mobile-loan',
              path: 'mobile-loan',
              beforeEnter: guardMyroute,
              component: () => import('../components/loans/mobileloan.vue'),
            },
            {
              name: 'buy-airtime',
              path: 'buy-airtime',
              beforeEnter: guardMyroute,
              component: () => import('../components/vas/buyairtime.vue'),
            },

          ]
        },
        {
          name: 'crm-member',
          path: 'crm-member',
          component: EmptyParentComponent,
          children: [
            {
              name: 'crm-MemberInquiry',
              path: 'crm-MemberInquiry',
              beforeEnter: guardMyroute,
              component: () => import('../components/CRM/MemberInquiry'),
            },
            {
              name: 'crm-ListCRMs',
              path: 'crm-ListCRMs',
              beforeEnter: guardMyroute,
              component: () => import('../components/CRM/ListCRMs'),
            },
            {
              name: 'crm-MyNotifications',
              path: 'crm-MyNotifications',
              beforeEnter: guardMyroute,
              component: () => import('../components/CRM/MyNotifications'),
            },
          ]
        },
          {
          name: 'checkoff',
          path: 'checkoff',
          component: EmptyParentComponent,
          children: [
            {
              name: 'checkoff-main',
              path: 'checkoff-main',
              beforeEnter: guardMyroute,
              component: () => import('../components/checkoff/CheckoffMain'),
            },
            {
              name: 'checkoff-details',
              path: 'checkoff-details/:checkoffNo/',
              beforeEnter: guardMyroute,
              component: () => import('../components/checkoff/individualCheckoff'),
            },
            {
              name: 'checkoff-Advice',
              path: 'checkoff-Advice',
              beforeEnter: guardMyroute,
              component: () => import('../components/checkoff/CheckoffAdvice'),
            },
            {
              name: 'checkoff-Advicedetails',
              path: 'checkoff-Advicedetails/:checkoffNo',
              beforeEnter: guardMyroute,
              component: () => import('../components/checkoff/CheckoffAdviceDetails'),
            },
          ]
        },
        {
          name: 'change-password',
          path: 'change-password',
          beforeEnter: guardMyroute,
          component: () => import('../components/user/ChangePin.vue')            
        }
      ],
    },
  ],
})
